import util from './shared/util.js';
import config from '../config.js';

var servicesURL = `${config.server.url}:${config.server.webServicesPort}/ai/`;

class cdoAI {
    chat = (data, callback) => {
        util.putJSON(servicesURL + 'chat', data, callback);
    }

    determineAction = (data, callback) => {
        util.putJSON(servicesURL + 'determine-action', data, callback);
    }

    chooseCombatAction = (data, callback) => {
        util.putJSON(servicesURL + 'choose-combat-action', data, callback);
    }

    describeCombatRound = (data, callback) => {
        util.putJSON(servicesURL + 'describe-combat-round', data, callback);
    }

    generateSettlementApproachImage = (data, callback) => {
        util.putJSON(servicesURL + 'generate-settlement-approach-image', data, callback);
    }

    generatePlaceApproachImage = (data, callback) => {
        util.putJSON(servicesURL + 'generate-place-approach-image', data, callback);
    }

    generateImage = (data, callback) => {
        return util.putJSON(servicesURL + 'generate-image', data, callback);
    }

    rewriteCharacterDescription = (data, callback) => {
        return util.putJSON(servicesURL + 'rewrite-character-description', data, callback);
    }

    generateCharacterAncestor = (data, callback) => {
        return util.putJSON(servicesURL + 'character-ancestor', data, callback);
    }

    generateCharacterGiftItem = (data, callback) => {
        return util.putJSON(servicesURL + 'character-gift-item', data, callback);
    }

    generateCharacterBackstory = (data, callback) => {
        return util.putJSON(servicesURL + 'character-backstory', data, callback);
    }

    updateSettlementMorningInhabitantLocations = (data, callback) => {
        util.putJSON(servicesURL + 'update-settlement-morning-inhabitant-locations', data, callback);
    }

    // THIS IS OLD OBSOLETE CODE, ONLY USE FOR REFERENCE IN PLAY2.JS REBUILD  *** DO NOT CALL DIRECTLY.
    startSettlementInteraction = (data, callback) => {
        util.putJSON(servicesURL + 'start-settlement-interaction', data, callback);
    }

    // THIS IS OLD OBSOLETE CODE, ONLY USE FOR REFERENCE IN PLAY2.JS REBUILD  *** DO NOT CALL DIRECTLY.
    interactWithSettlement = (data, callback) => {
        util.putJSON(servicesURL + 'interact-with-settlement', data, callback);
    }

    playerAction = (data, callback) => {
        util.putJSON(servicesURL + 'player-action', data, callback);
    }

    npcResponse = (data, callback) => {
        util.putJSON(servicesURL + 'npc-response', data, callback);
    }

    planCombatParticipation = (data, callback) => {
        util.putJSON(servicesURL + 'combat-participation', data, callback);
    }

    playNarration = (data, callback) => {
        util.putJSON(servicesURL + 'play-narration', data, callback);
    }
}

const cdo = new cdoAI();
export default cdo;
